module.exports = __webpack_public_path__ + "static/media/no-preview.b0d4a2a1.png";